import React, { useEffect, useRef, useState } from 'react';
import { Alert,View, Text, Image, StyleSheet, BackHandler, Platform, StatusBar, TouchableOpacity, TextInput, ScrollView, ImageBackground, SafeAreaView, Button, FlatList, ActivityIndicator, Linking, RefreshControl, } from 'react-native';
import Btn from "../components/btn"
import Colors from '../constants/Colors';
import { Ionicons, MaterialCommunityIcons } from "@expo/vector-icons"
import * as DocumentPicker from "expo-document-picker";
import * as ImagePicker from "expo-image-picker";
import { Audio } from 'expo-av';
import { useDispatch, useSelector } from 'react-redux';
import { getChatTicket, SetCahtTicket, SetCahtTicketWeb } from '../store/action/userProduct';

import { useIsFocused } from '@react-navigation/native';
import { NativeBaseProvider, Modal, useMediaQuery } from 'native-base';
import { logOut } from '../store/action/userLogin';
import AsyncStorage from '@react-native-async-storage/async-storage';
import NetInfo from "@react-native-community/netinfo";









const ChatTicket = (props) => {
    const baseUrl = "https://dl.dasterang.ir/ssdteam/npln/"
    //const tokens = "2|WHyjzuT213icASOZyDMHFmRUaYcJfLA5S9Y9kjhh"
    const tokens = useSelector((store) => store.userLogin.datatoken);
    const dispatch = useDispatch();

    const [recording, setRecording] = useState();
    const [showModal2, setshowModal2] = useState(false)
    const [State, setState] = useState({
        showModal: false,
        isLoading: false,
        isLoading1: false,
        isLoading2: false,
        //showModal2: false,
        stoped: false
    })
    const [focuse, setfocuse] = useState(false)

    const [texti, settext] = useState("");



    const [timing, settime] = useState("");
    
    const [Filesoundcheck, setFilesoundcheck] = useState("");


    const [selectedImage, setSelectedImage] = useState(null);



    const [Gallery, setGallery] = useState("");



    const [Chating, setChating] = useState([]);

    const [Play, setplay] = useState(false);


    const logOutHandler = async () => {
        try {
            //   console.log("logout");
            await dispatch(logOut());
            await AsyncStorage.removeItem("access_token");
            props.navigation.navigate("splash");
        } catch (err) {
            console.log(err);
        }
    };

    const [mytime, setmyTime] = useState(0);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (mytime !== 100) {
                setmyTime(mytime + 1);
            }
        }, 1000);
        return () => {
            clearTimeout(timer);
        };

    });





    const AddMessageTicketHandler = async () => {
        if (Platform.OS == "web") {
            try {
                setState({ ...State, isLoading1: true })

                if (texti) {

                    const res = await dispatch(SetCahtTicketWeb(tokens, "text", texti, props.route.params.Ticketid,))
                    //نسخه Pwaباید res.data باشد

                    if (res.data.status == "success") {
                        getChatTicketHandler()

                    }

                }

                if (Gallery) {


                    // console.log(Gallery);
                    const res = await dispatch(SetCahtTicketWeb(tokens, "file", Gallery, props.route.params.Ticketid,))

                    if (res.data.status == "success") {

                        getChatTicketHandler()

                    }

                }

                setState({ ...State, isLoading1: false })

            } catch (err) {

            }
        } else {

            try {
                setState({ ...State, isLoading1: true })

                if (texti) {

                    const res = await dispatch(SetCahtTicket(tokens, "text", texti, props.route.params.Ticketid,))

                    if (res.data.status == "success") {
                        getChatTicketHandler()

                    }

                }
                if (Filesoundcheck) {
                    setSelectedImage("")
                    setGallery("")
                    const res = await dispatch(SetCahtTicket(tokens, "file", Filesoundcheck, props.route.params.Ticketid,))
                    if (res.data.status == "success") {
                        getChatTicketHandler()

                    }
                }
                if (Gallery) {
                    setFilesoundcheck("")
                    setSelectedImage("")
                    // console.log(Gallery);
                    const res = await dispatch(SetCahtTicket(tokens, "file", Gallery, props.route.params.Ticketid,))

                    if (res.data.status == "success") {

                        getChatTicketHandler()

                    }

                }
                if (selectedImage) {
                    setFilesoundcheck("")
                    setGallery("")
                    // console.log(selectedImage);
                    const res = await dispatch(SetCahtTicket(tokens, "file", selectedImage, props.route.params.Ticketid))
                    // console.log(res.data);

                    if (res.data.status == "success") {

                        getChatTicketHandler()

                    }
                }

                setState({ ...State, isLoading1: false })

            } catch (err) {

            }

        }




    };



    const ref = useRef(null);
    const ref1 = useRef(null);
    const handleClick = () => {
        // 👇️ clear input field value
        ref.current.value = '';
        settext()

    };

    const handleClick1 = () => {
        // 👇️ clear input field value

        ref1.current.value = '';
        setGallery()

    };




    const getChatTicketHandler = async () => {
        try {


            setState({ ...State, isLoading1: true })
            const res = await dispatch(getChatTicket(tokens, props.route.params.Ticketid));



            setChating(res.data.data.messages)

            setState({ ...State, isLoading1: false })
            //console.log(res.data.data.messages);

        } catch (err) {

        }
    };
















    const isfocuce = useIsFocused();
    useEffect(() => {


        getChatTicketHandler()
        if (!tokens) {
            logOutHandler()
        }
        unsubscribe()

    }, [isfocuce])









    const openCamera = async () => {

        let result = await ImagePicker.launchCameraAsync({
            mediaTypes: ImagePicker.MediaTypeOptions.All,
            allowsEditing: false,
            quality: 0.7,
            base64: false
        });

        // console.log(result);

        if (!result.canceled) {
            // extract the filetype
            //setType(result.uri.substring(result.uri.lastIndexOf(".") + 1));
            setState({ ...State, isLoading2: true })
            setSelectedImage(result.assets[0].uri);
            // console.log(result);
            setshowModal2(true)

            setState({ ...State, isLoading2: false })

        }

    };




    //آپلود عکس
    const sendimageuploadHandler = async () => {
        try {

            let result = await DocumentPicker.getDocumentAsync();

            setGallery(result.uri);
           
            if (result.uri !==undefined) {
                setshowModal2(true)
           }

          

        } catch (err) {

            console.log(err);
        }
    };





    async function startRecording() {
        try {
            //console.log('Requesting permissions..');
            await Audio.requestPermissionsAsync();
            await Audio.setAudioModeAsync({
                allowsRecordingIOS: true,
                playsInSilentModeIOS: true,
            });
            //console.log('Starting recording..');
            const recording = new Audio.Recording();
            await recording.prepareToRecordAsync(Audio.RecordingOptionsPresets.HIGH_QUALITY);
            await recording.startAsync();
            setRecording(recording);
            //console.log('Recording started');
        } catch (err) {
            console.error('Failed to start recording', err);
        }
    }




    async function stopRecording() {
        //console.log('Stopping recording..');
        setState({ ...State, isLoading: true })
        setRecording(undefined);
        await recording.stopAndUnloadAsync();
        const sound = await recording.createNewLoadedSoundAsync();
        const uri = recording.getURI();
        const duration = getDurationFormatted(sound.status.durationMillis)
        console.log('Recording stopped and stored at', sound.status);
        setState({ ...State, isLoading: false })
        // settime(duration);
        // setsound1(sound)
        setFilesoundcheck(uri)


        // setState({ ...State, showModal2: true })
        setshowModal2(true)

    }



    function getDurationFormatted(millis) {
        const minutes = millis / 1000 / 60;
        const minutesDisplay = Math.floor(minutes);
        const secounds = Math.round((minutes - minutesDisplay) * 60);
        const secoundDisplay = secounds < 10 ? `0 ${secounds}` : secounds;
        return `${minutesDisplay} : ${secoundDisplay}`;
    }




    async function playSound(items) {

        // console.log('Loading Sound');
        // const { sound } = await Audio.Sound.createAsync({ uri: "http://cutunix.com" + items });

        // await sound.playAsync();

        //  console.log(sound);

        const { sound, status } = await Audio.Sound.createAsync(
            { uri: baseUrl + items },
            { shouldPlay: true },
            (status) => settime(status.didJustFinish),
            // (status) => console.log(status),


        );


    }







    function clickInput() {
        document.getElementById("fileC").click()


       
    }




    //قبل از ارسال
    async function playSound1(items) {

        const { sound, status } = await Audio.Sound.createAsync(
            { uri: items },
            { shouldPlay: true },
            (status) => settime(status.didJustFinish),
            // (status) => console.log(status),


        );


    }





    const handleOpenWithLinking = (msg) => {
        Linking.openURL(baseUrl + msg);
    };







    function handleBackButtonClick() {
        props.navigation.navigate("ticket");
        return true;

    }

    useEffect(() => {
        BackHandler.addEventListener("hardwareBackPress", handleBackButtonClick);
        return () => {
            BackHandler.removeEventListener("hardwareBackPress", handleBackButtonClick);
        };
    }, []);

    function unsubscribe() {
        NetInfo.fetch().then(state => {
            
        //   setNetwork(state)

          
            if (state.isConnected == false) {
                //  props.navigation.navigate("splash")
                Alert.alert("هشدار!", "لطفا اتصال اینترنت خود را بررسی کنید", [
                    
                    { text: "باشه", onPress: () => unsubscribe() }
                ]);
              // any thing you want to load before navigate home screen
            } 
         
        })
      };




    const [isSmallScreen] = useMediaQuery({
        // minHeight: 280,
        // maxHeight: 480,
        maxWidth: 500
    });


    return (

        // <TouchableWithoutFeedback onPress={() => Keyboard.dismiss()}>
        <NativeBaseProvider>



            <View
                //   onTouchStart={e=> y.current = e.nativeEvent.pageY}
                //   onTouchEnd={e => {
                //       // some threshold. add whatever suits you
                //       if (y.current - e.nativeEvent.pageY < 1) {
                //          getChatTicketHandler()
                //       }
                //     }}

                style={{
                    width: isSmallScreen ? "100%" : 500,
                    height: "100%",
                    marginLeft:isSmallScreen?0:"35%",
                    backgroundColor: Colors.background,
                    position: Platform.OS == "web" ? "fixed" : "relative"
                }}>




                {Platform.OS == "web" ?

                    <Modal justifyContent="center" size="xl"
                        isOpen={showModal2} onClose={() => setshowModal2(false)}>
                        <Modal.Content style={{ borderRadius: 30 }}>
                            <Modal.Body >

                                <View style={{ width: "100%", alignSelf: "auto" }}>
                                    <View style={{ width: "100%", height: 50, }}>
                                        <Ionicons onPress={() => {

                                            setshowModal2(false)

                                            setGallery("")
                                        }} name="close" size={20} color={Colors.black} />
                                    </View>




                                    <View style={{ width: "100%", height: 100, alignItems: "center", }}>

                                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: "red" }}>
                                            ... فایل ارسال شود ...</Text>
                                        <Text style={{ fontFamily: "MontserratBold",marginTop:20 }}>

                                            {Gallery ? Gallery.name :""}</Text>
                                    </View>




                                    <View style={{ width: "100%", flexDirection: "row" }}>

                                        <Btn
                                            label="انصراف"
                                            coloricon={Colors.background1}
                                            style={{ width: "45%", marginLeft: "5%", marginTop: 40, }}
                                            textStyle={{ bottom: 10, }}
                                            onPress={() => {


                                                setGallery("")
                                                setshowModal2(false)


                                            }}

                                        />
                                        <Btn
                                            label="تایید"
                                            touchableStyle={{ backgroundColor: Colors.success, elevation: 0 }}
                                            style={{ width: "45%", marginTop: 40, left: 10 }}
                                            textStyle={{ bottom: 10, }}
                                            onPress={() => {

                                                AddMessageTicketHandler()




                                                setGallery("")

                                                setmyTime(0)
                                                //  setFilesound(Filesoundcheck)
                                                setshowModal2(false)

                                            }}
                                        />
                                    </View>
                                </View>


                            </Modal.Body>

                        </Modal.Content>
                    </Modal>
                    

                    :

                    <Modal justifyContent="center" size="xl"
                        isOpen={showModal2} onClose={() => setshowModal2(false)}>
                        <Modal.Content style={{ borderRadius: 30 }}>
                            <Modal.Body >

                                <View style={{ width: "100%", alignSelf: "auto" }}>
                                    <View style={{ width: "100%", height: 50, }}>
                                        <Ionicons onPress={() => {

                                            setshowModal2(false)
                                            setFilesoundcheck("")
                                            setSelectedImage("")
                                            setGallery("")
                                        }} name="close" size={20} color={Colors.black} />
                                    </View>

                                    {Filesoundcheck ?
                                        <TouchableOpacity onPress={() => {
                                            setplay(!Play)
                                            playSound1(Filesoundcheck)

                                        }} style={{ left: 12, flexDirection: "row", width: "90%", height: 50, backgroundColor: Colors.secondText, alignItems: "center", borderRadius: 10 }}>

                                            <MaterialCommunityIcons name={Play == false || timing == true ? "motion-play-outline" : "motion-pause-outline"} size={40} color={Colors.primary} style={{ position: "absolute", right: 30 }} />
                                            <Text style={{ fontFamily: "MontserratBold", left: 30 }}>{Play == false || timing == true ? "پخش" : "در حال پخش"}</Text>
                                        </TouchableOpacity>
                                        :

                                        <View style={{ width: "100%", height: 100, alignItems: "center", }}>

                                            <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: "red" }}>
                                                ... فایل ارسال شود ...</Text>
                                            <Text style={{ fontFamily: "MontserratBold", }}>

                                                {Gallery ? Gallery : selectedImage}</Text>
                                        </View>


                                    }

                                    <View style={{ width: "100%", flexDirection: "row" }}>

                                        <Btn
                                            label="انصراف"
                                            coloricon={Colors.background1}
                                            style={{ width: "45%", marginLeft: "5%", marginTop: 40, }}
                                            textStyle={{ bottom: 10, }}
                                            onPress={() => {
                                                setFilesoundcheck("")
                                                setSelectedImage("")

                                                setGallery("")
                                                setshowModal2(false)


                                            }}

                                        />
                                        <Btn
                                            label="تایید"
                                            touchableStyle={{ backgroundColor: Colors.success, elevation: 0 }}
                                            style={{ width: "45%", marginTop: 40, left: 10 }}
                                            textStyle={{ bottom: 10, }}
                                            onPress={() => {

                                                AddMessageTicketHandler()



                                                setSelectedImage("")
                                                setGallery("")
                                                setFilesoundcheck("")
                                                setmyTime(0)
                                                //  setFilesound(Filesoundcheck)
                                                setshowModal2(false)

                                            }}
                                        />
                                    </View>
                                </View>


                            </Modal.Body>

                        </Modal.Content>
                    </Modal>
                }





                <View style={styles.viewHeader}>
                    <StatusBar backgroundColor={Colors.primary} />
                    <TouchableOpacity onPress={() => props.navigation.navigate("ticket")} style={styles.menu}   >
                        <Ionicons name="arrow-forward-outline" size={25} color={Colors.background} />
                    </TouchableOpacity>

                    <TouchableOpacity onPress={() => props.navigation.navigate("ticket")} style={styles.textheader}>
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, padding: "5%" }}>
                            بازگشت
                        </Text>
                    </TouchableOpacity>


                    <TouchableOpacity onPress={() => {
                        setmyTime(0)
                        getChatTicketHandler()
                    }}


                        style={{ flexDirection: "column", width: 50, height: Platform.OS == "web" ? 60 : 80, position: "absolute", left: "43%", bottom: Platform.OS == "web" ? "-5%" : -10, alignItems: "center", justifyContent: 'center' }}>

                        <MaterialCommunityIcons name="refresh" size={25} color={Colors.background} />
                        <Text style={{ fontFamily: "Montserrat", fontSize: 10, color: Colors.background }}>
                            بروزرسانی
                        </Text>
                    </TouchableOpacity>



                    <TouchableOpacity onPress={() => {
                        props.navigation.navigate("ticket")
                    }} style={styles.menu1}   >
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, padding: "5%" }}>
                            تایید نهایی
                        </Text>
                        <MaterialCommunityIcons name="check-circle-outline" size={25} color={Colors.background} />

                    </TouchableOpacity>



                </View>






                <ImageBackground style={{ width: "100%", height: Platform.OS == "web" ? "93%" : "100%", backgroundColor: Colors.primary }} resizeMode='cover' source={require("../../assets/image/wat.png")}>







                    <ScrollView showsVerticalScrollIndicator={false} style={{ marginBottom: Platform.OS == "web" ? 70 : 150 }}>




                        {Chating.slice(0).reverse().map((item, i) => {
                            return (

                                item.status == "user" ?

                                    <View key={i} style={{ alignSelf: "flex-end", margin: 10, backgroundColor: Colors.greenchat, borderRadius: 15, borderTopRightRadius: 0 }}>





                                        {item.mims == "jpg" || item.mims == "jpeg" || item.mims == "png"
                                            ?

                                            <TouchableOpacity onPress={() => {


                                                props.navigation.navigate("web", {
                                                    addressweb: baseUrl + item.msg
                                                })
                                                setmyTime(0)


                                            }}

                                                style={{ justifyContent: "center", alignItems: 'center', width: 150, height: 180, backgroundColor: Colors.background2, borderWidth: 2, borderColor: Colors.primary }}>

                                                <Image source={{ uri: baseUrl + item.msg }} alt="image" style={{ width: "99%", height: 175, }} />

                                            </TouchableOpacity>


                                            : item.mims == "m4a" || item.mims == "mp3" || item.mims == "mpeg" || item.mims == "3gp" ?



                                                <View style={{ flexDirection: "row" }}>

                                                    <TouchableOpacity onPress={() => {


                                                        props.navigation.navigate("web", {
                                                            addressweb: baseUrl + item.msg
                                                        })



                                                    }}
                                                        style={{ flexDirection: "row", right: 70, borderWidth: 2, borderColor: Colors.green, borderRadius: 15, width: 60, height: 50, alignItems: "center", justifyContent: "center" }}>
                                                        <MaterialCommunityIcons name="file-download-outline" size={25} color={Colors.primary} />
                                                        <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.black, }}>{item.mims}</Text>
                                                    </TouchableOpacity>

                                                    <TouchableOpacity onPress={() => {
                                                        setplay(item.id)
                                                        playSound(item.msg)


                                                    }} style={{ flexDirection: "row", left: Platform.OS === "web" ? 100 : 250, width: 200, height: 50, alignItems: "center", }}>

                                                        <MaterialCommunityIcons name={Play !== item.id || timing == true ? "motion-play-outline" : "motion-pause-outline"} size={40} color={Colors.primary} style={{ left: Platform.OS == "web" ? 45 : -110, position: Platform.OS == "web" ? "absolute" : "relative" }} />

                                                        <Text style={{ right: Platform.OS == "web" ? 280 : 350, fontFamily: "MontserratBold", position: Platform.OS == "web" ? "absolute" : "relative", width: 80, }}>{Play !== item.id || timing == true ? "پخش" : "درحال پخش"}</Text>
                                                    </TouchableOpacity>

                                                </View>
                                                : item.mims == "mp4" ?



                                                    <View style={{ flexDirection: "row" }}>

                                                        <TouchableOpacity onPress={() => {


                                                            props.navigation.navigate("web", {
                                                                addressweb: baseUrl + item.msg
                                                            })



                                                        }}
                                                            style={{ flexDirection: "row", right: 70, borderWidth: 2, borderColor: Colors.green, borderRadius: 15, width: 60, height: 50, alignItems: "center", justifyContent: "center" }}>
                                                            <MaterialCommunityIcons name="file-download-outline" size={25} color={Colors.primary} />
                                                            <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.black, }}>{item.mims}</Text>
                                                        </TouchableOpacity>

                                                        <TouchableOpacity onPress={() => {
                                                            // setplay(item.id)
                                                            // playSound(item.msg)
                                                            props.navigation.navigate("web", {
                                                                addressweb: baseUrl + item.msg
                                                            })

                                                            setmyTime(0)

                                                        }} style={{ flexDirection: "row", left: Platform.OS === "web" ? 100 : 250, width: 200, height: 50, alignItems: "center", }}>

                                                            <MaterialCommunityIcons name={Play !== item.id || timing == true ? "motion-play-outline" : "motion-pause-outline"} size={40} color={Colors.primary} style={{ left: Platform.OS == "web" ? 45 : -110, position: Platform.OS == "web" ? "absolute" : "relative" }} />

                                                            <Text style={{ right: Platform.OS == "web" ? 280 : 350, fontFamily: "MontserratBold", position: Platform.OS == "web" ? "absolute" : "relative", width: 80, }}>{Play !== item.id || timing == true ? "پخش" : "درحال پخش"}</Text>
                                                        </TouchableOpacity>

                                                    </View>
                                                    : item.mims == "text" ?

                                                        <Text style={{ alignSelf: "auto", fontFamily: "Montserrat", fontSize: 15, color: Colors.black, padding: "3%" }}> {item.msg} </Text>

                                                        :
                                                        <TouchableOpacity onPress={() => handleOpenWithLinking(item.msg)} style={{ flexDirection: "row", left: Platform.OS === "web" ? 100 : 250, width: 300, height: 50, alignItems: "center" }}>

                                                            <MaterialCommunityIcons name="download" size={30} color={Colors.primary} style={{ left: Platform.OS == "web" ? 140 : 0, position: Platform.OS == "web" ? "absolute" : "relative" }} />
                                                            <Text style={{ right: Platform.OS == "web" ? 320 : 250, fontFamily: "MontserratBold", position: Platform.OS == "web" ? "absolute" : "relative", }}>دانلود</Text>
                                                        </TouchableOpacity>
                                        }
                                    </View>
                                    :
                                    <View key={i} style={{ alignSelf: "flex-start", margin: 10, backgroundColor: Colors.background2, borderRadius: 15, borderTopLeftRadius: 0 }}>

                                        {item.mims == "jpg" || item.mims == "jpeg" || item.mims == "png"|| item.mims == "jfif"
                                            ?

                                            <TouchableOpacity
                                                onPress={() => {


                                                    props.navigation.navigate("web", {
                                                        addressweb: baseUrl + item.msg
                                                    })
                                                    setmyTime(0)


                                                }}


                                                style={{ justifyContent: "center", alignItems: 'center', width: 150, height: 180, backgroundColor: Colors.primary, borderWidth: 2, borderColor: Colors.primary }}>

                                                <Image source={{ uri: baseUrl + item.msg }} alt="image" style={{ width: "99%", height: 175, }} />

                                            </TouchableOpacity>


                                            : item.mims == "m4a" || item.mims == "mp3" || item.mims == "mpeg" || item.mims == "3gp" ?
                                                <View style={{ flexDirection: "row" }}>


                                                    <TouchableOpacity onPress={() => {
                                                        setplay(item.id)
                                                        playSound(item.msg)

                                                    }} style={{ flexDirection: "row", left: Platform.OS === "web" ? 100 : 250, width: 200, height: 50, alignItems: "center", }}>

                                                        <MaterialCommunityIcons name={Play !== item.id || timing == true ? "motion-play-outline" : "motion-pause-outline"} size={40} color={Colors.primary} style={{ left: Platform.OS == "web" ? 100 : -60, position: Platform.OS == "web" ? "absolute" : "relative" }} />
                                                        <Text style={{ right: Platform.OS == "web" ? 220 : 290, fontFamily: "MontserratBold", position: Platform.OS == "web" ? "absolute" : "relative", width: 80 }}>{Play !== item.id || timing == true ? "پخش" : "درحال پخش"}</Text>
                                                    </TouchableOpacity>
                                                    <TouchableOpacity onPress={() => {


                                                        props.navigation.navigate("web", {
                                                            addressweb: baseUrl + item.msg
                                                        })
                                                        setmyTime(0)


                                                    }} style={{ flexDirection: "row", left: 70, borderRadius: 15, width: 60, height: 50, alignItems: "center", justifyContent: "center", borderWidth: 2, borderColor: Colors.secondText3 }}>
                                                        <MaterialCommunityIcons name="file-download-outline" size={25} color={Colors.primary} />
                                                        <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.black, }}>{item.mims}</Text>
                                                    </TouchableOpacity>
                                                </View>
                                                : item.mims == "mp4" ?
                                                    <View style={{ flexDirection: "row" }}>


                                                        <TouchableOpacity onPress={() => {
                                                            // setplay(item.id)
                                                            // playSound(item.msg)

                                                            props.navigation.navigate("web", {
                                                                addressweb: baseUrl + item.msg
                                                            })
                                                            setmyTime(0)

                                                        }} style={{ flexDirection: "row", left: Platform.OS === "web" ? 100 : 250, width: 200, height: 50, alignItems: "center", }}>

                                                            <MaterialCommunityIcons name={Play !== item.id || timing == true ? "motion-play-outline" : "motion-pause-outline"} size={40} color={Colors.primary} style={{ left: Platform.OS == "web" ? 100 : -60, position: Platform.OS == "web" ? "absolute" : "relative" }} />
                                                            <Text style={{ right: Platform.OS == "web" ? 220 : 290, fontFamily: "MontserratBold", position: Platform.OS == "web" ? "absolute" : "relative", width: 80 }}>{Play !== item.id || timing == true ? "پخش" : "درحال پخش"}</Text>
                                                        </TouchableOpacity>
                                                        <TouchableOpacity onPress={() => {


                                                            props.navigation.navigate("web", {
                                                                addressweb: baseUrl + item.msg
                                                            })
                                                            setmyTime(0)


                                                        }} style={{ flexDirection: "row", left: 70, borderRadius: 15, width: 60, height: 50, alignItems: "center", justifyContent: "center", borderWidth: 2, borderColor: Colors.secondText3 }}>
                                                            <MaterialCommunityIcons name="file-download-outline" size={25} color={Colors.primary} />
                                                            <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.black, }}>{item.mims}</Text>
                                                        </TouchableOpacity>
                                                    </View>

                                                    : item.mims == "text" ?

                                                        <Text style={{ alignSelf: "auto", fontFamily: "Montserrat", fontSize: 15, color: Colors.black, padding: "3%" }}> {item.msg} </Text>

                                                        :
                                                        <TouchableOpacity onPress={() => handleOpenWithLinking(item.msg)} style={{ flexDirection: "row", left: Platform.OS === "web" ? 100 : 250, width: 300, height: 50, alignItems: "center" }}>

                                                            <MaterialCommunityIcons name="download" size={30} color={Colors.primary} style={{ left: Platform.OS == "web" ? 140 : 0, position: Platform.OS == "web" ? "absolute" : "relative" }} />
                                                            <Text style={{ right: Platform.OS == "web" ? 320 : 250, fontFamily: "MontserratBold", position: Platform.OS == "web" ? "absolute" : "relative", }}>دانلود - {item.mims}</Text>
                                                        </TouchableOpacity>
                                        }


                                    </View>


                            )
                        })}


                    </ScrollView>

                </ImageBackground>





































                {props.route.params.type == "ok" ?
                    <View style={{
                        flexDirection: "row",
                        width: isSmallScreen ? "100%" : 500,
                        height: 68,
                        backgroundColor: Colors.secondText2,
                        position: Platform.OS == "web" ? "fixed" : "absolute",
                        bottom: Platform.OS == "web" ? 0 : 0.1,


                    }}>
                        <Text style={{ fontFamily: "Montserrat", fontSize: 20, color: Colors.primary, left: 100, top: 10 }}>نمیتوانید پیامی ارسال کنید.</Text>
                    </View> :

                    Platform.OS === "web" ?
                        <View style={{
                            flexDirection: "row",
                            width: isSmallScreen ? "100%" : 500,
                            height: 68,
                            backgroundColor: Colors.secondText2,
                            position: Platform.OS == "web" ? "fixed" : "absolute",
                            bottom:  0.1,


                        }}>



                            {Chating.length == [] ?
                                <View></View> :


                                !State.isLoading1 ?
                                    <View></View> :
                                    <View style={{ flexDirection: "row", width: 73, height: 40, backgroundColor: Colors.primary, borderRadius: 20, alignItems: "center", justifyContent: "center", bottom: "105%", left: "45%", position: "absolute" }}>

                                        <ActivityIndicator size={30} color={Colors.background} />
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.background, marginLeft: 5 }}>{mytime}%</Text>
                                    </View>

                            }

                            <TouchableOpacity onPress={() => {

                                AddMessageTicketHandler()



                                handleClick()


                                handleClick1()
                                setmyTime(0)




                                // getChatHandler('true')


                            }} style={{ top: "26%", right: "2%", position: "absolute" }}>


                                <MaterialCommunityIcons name="send-outline" size={30} color={texti || Gallery ? Colors.success : Colors.black} />

                            </TouchableOpacity>

                            <View>

                                <form onSubmit={AddMessageTicketHandler}>


                                    <input
                                        style={{
                                            width: 190, height: "30%", position: "absolute", left: 110, top: "20%", borderRadius: 10,
                                            paddingLeft: "8px",
                                            paddingTop: "6px",
                                            paddingBottom: "6px",
                                            fontFamily: "Montserrat"

                                        }}
                                        ref={ref}
                                        type="text"
                                        onChange={(e) => settext(e.target.value)}
                                        placeholder={"                   متن خودرا وارد کنید"}
                                    />
                                    <br />
                                    <MaterialCommunityIcons style={{ marginLeft: 10, position: "absolute", top: 16 }} onPress={clickInput} name="camera-outline" size={25} color={Colors.black} />
                                    <MaterialCommunityIcons style={{ marginLeft: 45, position: "absolute", top: 16 }} onPress={clickInput} name="link-variant" size={25} color={Colors.black} />
                                    <MaterialCommunityIcons style={{ marginLeft: 80, position: "absolute", top: 16 }} onPress={clickInput} name="microphone" size={25} color={Colors.black} />
                                    {/* <span style={{fontFamily: "Montserrat", fontSize: 13,marginLeft:45,color:Gallery ? Colors.success:Colors.black}}>{Gallery ? "انتخاب شده" :"انتخاب فایل"}</span> */}


                                    <input
                                        id="fileC" ref={ref1} type="file" hidden onChange={(e) => {
                                        
                                            setGallery(e.target.files[0])
                                            setshowModal2(true)
                                        
                                        
                                        }}
                                        style={{ marginLeft: "4%", marginTop: 2, }}
                                    />
                                    <br />





                                </form>
                            </View>


                        </View>
                        :

                        <View style={{
                            flexDirection: "row",
                            width: isSmallScreen ? "100%" : 500,
                            height: 68,
                            backgroundColor: Colors.secondText2,
                            position: Platform.OS == "web" ? "fixed" : "absolute",
                            bottom: 0.1,


                        }}>



                            {Chating.length == [] ?
                                <View></View> :


                                !State.isLoading1 ?
                                    <View></View> :
                                    <View style={{ flexDirection: "row", width: 73, height: 40, backgroundColor: Colors.primary, borderRadius: 20, alignItems: "center", justifyContent: "center", bottom: "105%", left: "45%", position: "absolute" }}>

                                        <ActivityIndicator size={30} color={Colors.background} />
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.background, marginLeft: 5 }}>{mytime}%</Text>
                                    </View>

                            }

                            <TouchableOpacity onPress={() => {

                                AddMessageTicketHandler()



                                settext("")
                                setFilesoundcheck("")
                                setSelectedImage("")
                                setGallery("")
                                setmyTime(0)

                                // getChatHandler('true')


                            }} style={{ top: "26%", right: "2%", position: "absolute" }}>


                                <MaterialCommunityIcons name="send-outline" size={30} color={texti || selectedImage || Gallery || Filesoundcheck ? Colors.success : Colors.black} />

                            </TouchableOpacity>


                            <TextInput onFocus={() => setfocuse(true)} value={texti ? texti :
                                selectedImage ? selectedImage :
                                    Gallery ? Gallery : Filesoundcheck

                            }
                                editable={selectedImage ? false : Gallery ? false : Filesoundcheck ? false : true}
                                onChangeText={(t) => settext(t)} placeholder="متن خود را وارد کنید" multiline
                                onBlur={() => setfocuse(false)} keyboardType="default" style={{ paddingLeft: Platform.OS === "web" ? "27%" : "35%", paddingTop: "3%", position: "absolute", top: "10%", right: "10%", backgroundColor: Colors.background1, width: "60%", height: 50, borderWidth: (focuse == true ? 2 : 0), borderRadius: 25, padding: 10, fontFamily: "Montserrat", borderColor: (focuse == true ? Colors.black : Colors.secondText3), }} />


                            <TouchableOpacity onPress={recording ? stopRecording : startRecording} style={{ bottom: "28%", left: "20%", position: "absolute" }}>
                                {State.isLoading ?
                                    <ActivityIndicator color={Colors.primary} style={{ marginLeft: 8 }} />
                                    :
                                    <SafeAreaView>
                                        <MaterialCommunityIcons name={recording ? "wifi" : ""} size={20} color={recording ? Colors.success : Colors.black} style={{ left: 5 }} />
                                        <MaterialCommunityIcons name={recording ? "microphone" : "microphone-off"} size={30} color={recording ? Colors.success : Colors.black} />
                                    </SafeAreaView>
                                }
                            </TouchableOpacity>


                            <TouchableOpacity onPress={() => sendimageuploadHandler()} style={{ top: "25%", left: "11%", position: "absolute" }}>
                                <MaterialCommunityIcons name="link-variant" size={30} color={Colors.black} />
                            </TouchableOpacity>


                            <TouchableOpacity onPress={() => openCamera()} style={{ top: "30%", left: "3%", position: "absolute" }}>
                                <MaterialCommunityIcons name="camera-outline" size={25} color={Colors.black} />
                            </TouchableOpacity>


                        </View>
                }




            </View>
        </NativeBaseProvider>
        // </TouchableWithoutFeedback>

    );
}


const styles = StyleSheet.create({

    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background,
        position: Platform.OS == "web" ? "fixed" : "relative"
    },
    viewHeader: {
        flexDirection: "row",
        width: "100%",
        height: Platform.OS == "web" ? 60 : 80,
        backgroundColor: Colors.primary,


    },

    menu: {
        backgroundColor: Colors.primary,
        width: 40,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 15,
        top: Platform.OS == "web" ? "20%" : "35%",

    },
    menu1: {
        backgroundColor: Colors.primary,
        width: 110,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        left: "3%",
        top: Platform.OS == "web" ? "17%" : "35%",
        flexDirection: "row"

    },
    textheader: {
        backgroundColor: Colors.primary,
        width: 60,
        height: 60,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: "12%",
        top: Platform.OS == "web" ? "3%" : "22%"
    },
    viewfooter: {
        flexDirection: "row",
        width: "100%",
        height: 68,
        backgroundColor: Colors.secondText2,
        position: Platform.OS == "web" ? "fixed" : "absolute",
        bottom: Platform.OS == "web" ? 0 : 0.1,


    }


})




export default ChatTicket


